
import React from "react";
import {Link} from "react-router-dom";

export default function OrderDetails({  order, orderLoading  }) {
    const subtotal = order?.items?.reduce((sum, item) => sum + item.totalPrice, 0) || 0;

    return (
        <div
            className="modal fade modalCentered modal-order-detail"
            id="order_detail"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="header">
                        <div className="heading">Order Detail</div>
                        <span
                            className="icon-close icon-close-popup"
                            data-bs-dismiss="modal"
                        />
                    </div>

                    {orderLoading || !order ? (
                        <div className="modal-body text-center p-5">
                            <span className="loader"/>
                        </div>
                    ) : (
                        <>
                            <ul className="list-infor">
                                <li>#{order.orderNumber}</li>
                                <li>{new Date(order.orderDate).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                })}</li>

                                <li>{order.items.reduce((sum, item) => sum + item.quantity, 0)} items</li>
                                <li
                                    className={
                                        ["cancelled", "rejected"].includes(order.status.toLowerCase())
                                            ? "text-danger"
                                            : ["cancelrequested", "refundrequested"].includes(order.status.toLowerCase())
                                                ? "text-warning"
                                                : `text-${order.status.toLowerCase()}`
                                    }
                                >
                                    {order.status === "CancelRequested"
                                        ? "Cancel Requested"
                                        : order.status === "RefundRequested"
                                            ? "Refund Requested"
                                            : order.status}
                                </li>


                            </ul>

                            <div className="tb-order-detail">
                                <div className="top">
                                    <div className="title item">Product</div>
                                    <div className="title item d-md-block d-none">Quantity</div>
                                    <div className="title item d-md-block d-none">Price</div>
                                    <div className="title item d-md-block d-none">Total</div>
                                </div>

                                <div className="tb-content">
                                    {order?.items?.map((item, i) => (
                                        <div key={i} className="order-detail-item">
                                            <div className="item">
                                                <div className="infor-content">
                                                    <div className="image">
                                                        <Link to={`/product-detail/${item.slug}`}>
                                                            <img
                                                                src={item.image || "/images/default.jpg"}
                                                                alt={item.name}
                                                                width={100}
                                                                height={140}
                                                            />
                                                        </Link>
                                                    </div>
                                                    <div>
                                                        <Link className="link" to={`/product-detail/${item.slug}`}>
                                                            {item.name}
                                                        </Link>
                                                        <div className="size">{item.size}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="item" data-title="Quantity">
                                                {item.quantity}
                                            </div>
                                            <div className="item" data-title="Price">
                                                £{item.unitPrice.toFixed(2)} <small className="text-muted">(excl.
                                                tax)</small>
                                            </div>
                                            <div className="item" data-title="Total">
                                                £{item.totalPrice.toFixed(2)}<small className="text-muted">(incl.
                                                tax)</small>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="order-detail-item subtotal">
                                        <div className="item d-md-block d-none"/>
                                        <div className="item d-md-block d-none"/>
                                        <div className="item subtotal-text">Subtotal:</div>
                                        <div className="item subtotal-price">
                                            £{subtotal.toFixed(2)} GBP
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bottom text-center">
                                Not happy with the order? You can{" "}
                                <Link to={`/return-and-refund`} className="fw-medium btn-underline">
                                    Request a free return
                                </Link>{" "}
                                in <span className="fw-medium">14 days</span>
                            </div>

                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
